export const languageTextMain ={

    // Copyright Text Start
    copyRight: "ลิขสิทธิ์ (c) 2014 แมคควอรีกรุ๊ป จำกัด ABN 94 122 169 279 สงวนลิขสิทธิ์",
    copyRightEn: "Copyright (c) 2016 Macquarie Group Limited ABN 94 122 169 279. All rights reserved",
    // Copyright Text End

    // Prev and Next Links Start
    homeLink: "หน้าหลัก",
    homeLinkEn: "Home",

    whyTradeDW: "ทำไมต้องลงทุนใน DW?",
    whyTradeDWEn: "Why Trade DW?",

    gearingEffect: "อัตราทด (Gearing Effect)",
    gearingEffectEn: "Gearing effect",

    limitedLoss: "จำกัดขาดทุน",
    limitedLossEn: "Limited loss",

    profitFromBullBearMarket: "ความสามารถในการทำกำไรจากการขาขึ้นและลง",
    profitFromBullBearMarketEn: "Ability to profit form rises and falls",

    noMarginCall: "ไม่มีการเรียกหลักประกันเพิ่ม",
    noMarginCallEn: "No margin call",

    lowerCapitalOutlay: "ใช้เงินลงทุนต่ำกว่า",
    lowerCapitalOutlayEn: "Lower capital outlay",

    releasingShareCapital: "ลดจำนวนเงินลงทุนในหลักทรัพย์",
    releasingShareCapitalEn: "Releasing share capital",

    easeOfTrade: "ซื้อง่ายขายคล่อง",
    easeOfTradeEn: "Ease of trade",

    whatAreWarrants: "DW คืออะไร?",
    whatAreWarrantsEn: "What are DW?",

    callPut: "Call vs Put",
    callPutEn: "Call vs Put",

    howCallWork: "Call DW ทำงานอย่างไร",
    howCallWorkEn: "How a Call DW works",

    howPutWork: "Put DW ทำงานอย่างไร",
    howPutWorkEn: "How a Put DW works", 

    howAreWarrant: "สัญลักษณ์ของ DW เป็นอย่างไร",
    howAreWarrantEn: "How are DW named?",
    
    howAreWarrantsPriced: "ราคา DW คำนวณอย่างไร",
    howAreWarrantsPricedEn: "How are DW priced?",

    stockPrice: "ราคาหุ้นอ้างอิง",
    stockPriceEn: "Stock Price",

    exercisePrice: "ราคาใช้สิทธิ",
    exercisePriceEn: "Exercise Price",

    expiryDate: "วันครบกำหนดอายุ",
    expiryDateEn: "Expiry Date",

    volatility: "ความผันผวน",
    volatilityEn: "Volatility",

    interestRates: "อัตราดอกเบี้ย",
    interestRatesEn: "Interest Rates",

    intrinsicValueAndTimeValue: "มูลค่าที่แท้จริงและมูลค่าเวลา",
    intrinsicValueAndTimeValueEn: "Intrinsic Value & Time Value",

    timeDecay: "Time Decay",
    timeDecayEn: "Time Decay",

    moneyNess: "สถานะของ DW (Moneyness)",
    moneyNessEn: "Moneyness",

    trackingWarrant: "การติดตามการเปลี่ยนแปลงของราคา DW",
    trackingWarrantEn: "Tracking DW's price change",

    calculatingDwdailyChange: "การคำนวณ % การเปลี่ยนแปลงของราคา DW ในแต่ละวัน",
    calculatingDwdailyChangeEn: "Calculating a DW's daily % change",

    usefulWarrantTerms: "ตัวแปรเกี่ยวกับ DW ที่ควรรู้",
    usefulWarrantTermsEn: "Useful DW terms",

    delta: "เดลต้า (Delta)",
    deltaEn: "Delta",

    exerciseRatio: "DW ต่อหุ้น (DWPS)",
    exerciseRatioEn: "DW per share (DPWS)",

    dWSensitivity: "DW Sensitivity",
    dWSensitivityEn: "DW Sensitivity",

    breakEvenPrice: "จุดคุ้มทุน (Breakeven Price)",
    breakEvenPriceEn: "Breakeven Price",

    premium: "Premium หรือ Time Value ",
    premiumEn: "Premium ",

    gearing: "อัตราทด (Gearing) ", 
    gearingEn: "Gearing ",

    effectiveGearing: "Effective Gearing ",
    effectiveGearingEn: "Effective Gearing ",

    impliedVolatility: "ความผันผวนแฝง (Implied Volatility) ",
    impliedVolatilityEn: "Implied Volatility ",

    howtoSelectaWarrant: "วิธีการเลือก DW",
    howtoSelectaWarrantEn: "How to select a DW?",

    fourViewonUnderlyingShareorIndex: "มุมมองบนหุ้นอ้างอิง",
    fourViewonUnderlyingShareorIndexEn: "View on Underlying Share or Index",

    timeFrame: "ระยะเวลาลงทุน",
    timeFrameEn: "Timeframe",

    fourGearingLevel: "อัตราทด (Gearing)",
    fourGearingLevelEn: "Gearing Level",

    fourImpliedVolatility: "ความผันผวนแฝง (Implied Volatility)",
    fourImpliedVolatilityEn: "Implied Volatility",

    qualityOfaMarketMaker: "คุณภาพของผู้ดูแลสภาพคล่อง",
    qualityOfaMarketMakerEn: "Quality of a Market Maker",

    riskMatrix: "Matrix ความเสี่ยง",
    riskMatrixEn: "Risk Matrix",

    tipsAndTools: "เคล็ดลับและเครื่องมือ",
    tipsAndToolsEn: "Tips and Tools",

    singleShareCallsAndPutsAtExpiry: "DW ณ วันครบกำหนดอายุ",
    singleShareCallsAndPutsAtExpiryEn: "DW at expiry",

    warrantsAtExpiryLastTradingDay: "วันซื้อขายสุดท้าย",
    warrantsAtExpiryLastTradingDayEn: "Last trading day",

    cashSettlementAmountForSingleShareWarrantsAtExpiry: "เงินสดส่วนต่างจากการใช้สิทธิ DW",
    cashSettlementAmountForSingleShareWarrantsAtExpiryEn: "Settlement value for DW",

    singleShareCallWarrantExample: "ตัวอย่าง Call DW",
    singleShareCallWarrantExampleEn: "Call DW Example",

    singleSharePutWarrantExample: "ตัวอย่าง Put DW",
    singleSharePutWarrantExampleEn: "Put DW Example",

    risk: "ความเสี่ยง",
    riskEn: "Risk",

    marketRisk: "ความเสี่ยงด้านตลาด (Market Risk)",
    marketRiskEn: "Market Risk",

    riskGearing: "ความเสี่ยงจาก (Gearing)",
    riskGearingEn: "Gearing",

    limitedLife: "อายุจำกัด (Limited Life)",
    limitedLifeEn: "Limited Life",

    creditRisk: "Credit Risk",
    creditRiskEn: "Credit Risk",

    takeOvers: "การควบรวมกิจการ",
    takeOversEn: "Takeovers",

    marketMakers: "สภาพคล่องและการดูแลสภาพคล่อง",
    marketMakersEn: "Market Makers and Liquidity",

    howToCalculateCashSettlementAmount: "วิธีการดูแลสภาพคล่อง",
    howToCalculateCashSettlementAmountEn: "How does it works?",

    liquidityTradedVolume: "สภาพคล่องและปริมาณการซื้อขาย",
    liquidityTradedVolumeEn: "Liquidity vs Traded Volume",

    howDoMarketMakersHedge: "ผู้ดูแลสภาพคล่อง <br /> บริหารความเสี่ยงอย่างไร",
    howDoMarketMakersHedgeEn: "How do Market Makers hedge",
    // Prev and Next Links End
    
}